export default __webpack_public_path__ + "static/media/gallery_01.dcc8e75a.jpg";